import {
    canActivateNow,
    canDisplayNow,
    shouldDisplayActivateDeadlineAt,
    shouldDisplayActivatedAt,
    shouldDisplayRefundDeadlineAt,
    isSameDeviceId,
    isUsableTicket,
    isComboTicket,
} from '../utils';

export const orderTicketUtilTest = (orderTicket) => {
    try {
        console.log('orderTicket check', {
            canActivateNow: canActivateNow(orderTicket),
            canDisplayNow: canDisplayNow(orderTicket),
            shouldDisplayActivateDeadlineAt: shouldDisplayActivateDeadlineAt(orderTicket),
            shouldDisplayActivatedAt: shouldDisplayActivatedAt(orderTicket),
            shouldDisplayRefundDeadlineAt: shouldDisplayRefundDeadlineAt(orderTicket),
            isSameDeviceId: isSameDeviceId(orderTicket, 'test'),
            isUsableTicket: isUsableTicket(orderTicket),
            isComboTicket: isComboTicket(orderTicket),
        });
    } catch (error) {
        console.error(error, JSON.stringify(orderTicket));
    }
};
